import { type FC } from 'react'
import { Layout } from '@egw/layouts'
import { Headers } from '@egw/components'
import { useTranslation } from '@egw/i18n'
import { RecoveryVerificationPage, RecoveryVerificationPageV2 } from '@egw/features-auth'
import { useFlags } from '@egw/feature-flags'
import { type FeatureFlags } from '@egw/constants'

export const PasskeyRecoveryVerificationPage: FC = () => {
  const { t } = useTranslation()
  const { flags } = useFlags<FeatureFlags>()

  return (
    <Layout>
      <Headers title={t('pages.recovery.title')} />
      {flags.rolloutIntegratedDocumentVerification ? <RecoveryVerificationPageV2 /> : <RecoveryVerificationPage />}
    </Layout>
  )
}
